import TabButton from './parts/TabButton'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

export type DetailTab = 'items' | 'history'

interface DetailTabsProps {
    activeTab: DetailTab
    itemCount: number
    historyCount: number
    onChange: (tab: DetailTab) => void
}

const DetailTabs: FC<DetailTabsProps> = ({ activeTab, itemCount, historyCount, onChange }) => {
    const { t } = useTranslation('app')

    return (
        <View accessibilityRole="tablist" style={styles.container}>
            <TabButton
                active={activeTab === 'items'}
                count={itemCount}
                label={t('openTabs.detail.items')}
                onPress={() => onChange('items')}
            />
            <TabButton
                active={activeTab === 'history'}
                count={historyCount}
                label={t('openTabs.detail.history')}
                onPress={() => onChange('history')}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: { minHeight: 36, flexDirection: 'row', alignItems: 'center', gap: 4 },
})

export default DetailTabs
